import script from "./add-edit-ops.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-edit-ops.vue?vue&type=script&lang=ts&setup=true"

import "./add-edit-ops.vue?vue&type=style&index=0&id=fd9e9982&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd9e9982"]])

export default __exports__